import { type ComponentProps, type FC, Fragment } from "react";
import { WorkWithShopWorkCassette } from "@userFrontend/features/publication/components/WorkWithShopWorkCassette";
import { PremiumBanner } from "./uiParts/PremiumBanner";
import * as styles from "./styles.css";

type Props = {
  works: ComponentProps<typeof WorkWithShopWorkCassette>[];
  premiumBanner?: ComponentProps<typeof PremiumBanner>;
};

export const Presentation: FC<Props> = ({ works, premiumBanner }) => {
  return (
    <>
      {works.map((work, index) => (
        <Fragment key={work.workCode}>
          <div className={styles.item}>
            <WorkWithShopWorkCassette {...work} />
          </div>
          {premiumBanner && index === 4 && (
            <div className={styles.item}>
              <PremiumBanner {...premiumBanner} />
            </div>
          )}
        </Fragment>
      ))}
    </>
  );
};
